import { useMemo } from 'react';

const TAB_ID_STORAGE_KEY = 'orderbot.tab_id';

// Browser-session primitive. Each tab gets its own id via sessionStorage so a
// page refresh keeps the same id while a new tab gets a fresh one — used as a
// per-tab viewer lease key. Callable outside React (e.g. router `beforeLoad`
// when wiring a service that needs the tab id for request headers).
export function getTabId(): string {
  const existing = sessionStorage.getItem(TAB_ID_STORAGE_KEY);
  if (existing !== null) {
    return existing;
  }

  const fresh = crypto.randomUUID();
  sessionStorage.setItem(TAB_ID_STORAGE_KEY, fresh);

  return fresh;
}

export function useTabId(): string {
  return useMemo(() => getTabId(), []);
}
